import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

export { DialogRef, DIALOG_DATA };
